<template>
  <div class="mobile-floating-contact" :style="{ right: positionX + 'px', bottom: positionY + 'px' }">
    <button class="contact-btn" @click="toggleContact" @touchstart="startDrag">
      <svg v-if="!showContact" class="message-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
        <path d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z" />
      </svg>
      <svg v-else class="close-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
        <line x1="18" y1="6" x2="6" y2="18" />
        <line x1="6" y1="6" x2="18" y2="18" />
      </svg>
    </button>
    <transition name="slide-fade">
      <div class="contact-panel" v-show="showContact">
        <div class="panel-header">
          <h3>{{ $t('contact_list.touch') }}</h3>
          <p>{{ $t('contact_list.help') }}</p>
        </div>
        <div class="panel-close" @click="toggleContact">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <line x1="18" y1="6" x2="6" y2="18" />
            <line x1="6" y1="6" x2="18" y2="18" />
          </svg>
        </div>
        <div class="contact-methods">
          <div class="contact-method">
            <div class="method-icon">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z" />
              </svg>
            </div>
            <div class="method-content">
              <span class="method-title">{{ $t('contact_list.phone') }}</span>
              <span class="method-value">{{ chatinfo.contact_phone }}</span>
            </div>
          </div>
			
            <div class="contact-method">
              <div class="method-icon">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
                  <polyline points="22,6 12,13 2,6" />
                </svg>
              </div>
              <div class="method-content">
                <span class="method-title">{{ $t('contact_list.email') }}</span>
                <span class="method-value">{{ chatinfo.contact_email }}</span>
              </div>
            </div>
			
			
            <div class="contact-method">
              <div class="method-icon">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <path d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z" />
                </svg>
              </div>
              <div class="method-content">
                <span class="method-title">{{ $t('contact_list.whatsapp') }}</span>
                <span class="method-value">{{ chatinfo.contact_whatsapp }}</span>
              </div>
            </div>
			
			<div class="contact-method">
			  <div class="method-icon">
			    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
			      <path d="M12 2C6.48 2 2 6.48 2 12c0 4.42 2.87 8.17 6.84 9.54L12 22l3.16-0.46C19.13 20.17 22 16.42 22 12c0-5.52-4.48-10-10-10z" />
			      <path d="M16 8c2.21 0 4 1.79 4 4s-1.79 4-4 4-4-1.79-4-4 1.79-4 4-4zm-8 0c2.21 0 4 1.79 4 4s-1.79 4-4 4-4-1.79-4-4 1.79-4 4-4z" />
			    </svg>
			  </div>
			  <div class="method-content">
			    <img style="width: 70%;height: 70%;" :src="chatinfo.contact_wechat_url" alt="WeChat" />
				<p>{{ $t('contact_list.wechat_tips') }}</p>
			  </div>
			</div>
			
			
			<div class="contact-method">
			  <div class="method-icon">
			    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
			      <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z" />
			    </svg>
			  </div>
			  <div class="method-content">
			    <img style="width: 70%;height: 70%;" :src="chatinfo.contact_whatsapp_url" alt="WhatsApp" />
				   <p>{{ $t('contact_list.whatsapp_tips') }}</p>
			  </div>
			</div>
          </div>
          <div class="panel-footer">
            <p>{{ $t('contact_list.Available') }}</p>
          </div>
        </div>
      </transition>
    </div>
  </template>

<script>
export default {
  name: 'MobileContact',
  data() {
    return {
      showContact: false,
      isDragging: false,
      startX: 0,
      startY: 0,
      initialX: 0,
      initialY: 0,
      positionX: 15,
      positionY: 20,
	  chatinfo: []
    }
  },
  created() {
  	const country=localStorage.getItem('mobile_country')
    this.$http.get('/index/contact_information',{ country: country }).then(res => {
  		this.chatinfo = res.data || []
    })
  },
  methods: {
    toggleContact() {
      this.showContact = !this.showContact
	  if(this.showContact){
		  const country=localStorage.getItem('mobile_country')
		  this.$http.get('/index/contact_information',{ country: country }).then(res => {
			this.chatinfo = res.data || []
		  })  
	  }
    },
    goPage() {
      const { href } = this.$router.resolve({ 
        name: 'Page', 
        params: { type: "Production" }
      });
      const newWindow = window.open(href, '_blank');
      if (!newWindow) {
        alert('Browser pop-up is blocked, please allow pop-up permission to continue accessing');
      }
    },
    startDrag(e) {
      this.isDragging = true;
      this.startX = e.touches[0].clientX;
      this.startY = e.touches[0].clientY;
      this.initialX = this.positionX;
      this.initialY = this.positionY;
      document.addEventListener('touchmove', this.drag);
      document.addEventListener('touchend', this.endDrag);
    },
    drag(e) {
      if (!this.isDragging) return;
      const deltaX = e.touches[0].clientX - this.startX;
      const deltaY = e.touches[0].clientY - this.startY;
      this.positionX = this.initialX - deltaX;
      this.positionY = this.initialY - deltaY;
      
      // 限制在屏幕范围内
      const screenWidth = window.innerWidth;
      const screenHeight = window.innerHeight;
      const buttonSize = 56;
      
      this.positionX = Math.max(0, Math.min(screenWidth - buttonSize, this.positionX));
      this.positionY = Math.max(0, Math.min(screenHeight - buttonSize, this.positionY));
    },
    endDrag() {
      this.isDragging = false;
      document.removeEventListener('touchmove', this.drag);
      document.removeEventListener('touchend', this.endDrag);
    }
  }
}
</script>

<style scoped>
.mobile-floating-contact {
  position: fixed;
  z-index: 9999;
}

.contact-btn {
  width: 56px;
  height: 56px;
  background-color: #1989fa;
  color: white;
  border: none;
  border-radius: 50%;
  cursor: pointer;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  touch-action: none;
}

.contact-btn:hover {
  background-color: #409eff;
  transform: translateY(-2px);
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.2);
}

.message-icon, .close-icon {
  width: 20px;
  height: 20px;
}

.contact-panel {
  position: fixed;
  right: 0;
  bottom: 56px;
  background-color: white;
  border-radius: 12px 0 0 12px;
  padding: 20px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);
  width: 280px;
  max-height: 80vh;
  overflow-y: auto;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
}

/* @media (max-width: 768px) {
  .contact-panel {
    right: auto;
    left: 50%;
    transform: translateX(-50%);
    bottom: 70px;
  }
} */

.panel-header {
  text-align: center;
  margin-bottom: 24px;
}

.panel-header h3 {
  margin: 0 0 8px 0;
  color: #303133;
  font-size: 18px;
  font-weight: 600;
}

.panel-header p {
  margin: 0;
  color: #606266;
  font-size: 14px;
}

.contact-methods {
  margin-bottom: 24px;
}

.contact-method {
  display: flex;
  align-items: center;
  padding: 12px 0;
  border-bottom: 1px solid #f0f0f0;
}

.contact-method:last-child {
  border-bottom: none;
}

.method-icon {
  width: 40px;
  height: 40px;
  background-color: #f5f7fa;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 16px;
  color: #1989fa;
}

.method-icon svg {
  width: 20px;
  height: 20px;
}

.method-content {
  flex: 1;
}

.method-title {
  display: block;
  color: #606266;
  font-size: 12px;
  margin-bottom: 3px;
}

.method-value {
  display: block;
  color: #303133;
  font-size: 14px;
  font-weight: 500;
}

.wechat-qr {
  text-align: center;
  margin-bottom: 24px;
}

.qr-code img {
  width: 120px;
  height: 120px;
  border: 1px solid #f0f0f0;
  border-radius: 8px;
}

.panel-close {
  position: absolute;
  top: 16px;
  right: 16px;
  width: 24px;
  height: 24px;
  cursor: pointer;
  color: #606266;
  transition: color 0.3s ease;
}

.panel-close:hover {
  color: #303133;
}

.panel-close svg {
  width: 20px;
  height: 20px;
}

.qr-code p {
  margin: 8px 0 0 0;
  color: #606266;
  font-size: 12px;
}

.panel-footer {
  text-align: center;
  padding-top: 16px;
  border-top: 1px solid #f0f0f0;
}

.panel-footer p {
  margin: 0;
  color: #909399;
  font-size: 13px;
}

.slide-fade-enter-active {
  transition: all 0.3s ease-out;
}

.slide-fade-leave-active {
  transition: all 0.3s cubic-bezier(1, 0.5, 0.8, 1);
}

.slide-fade-enter-from,
.slide-fade-leave-to {
  transform: translateX(20px);
  opacity: 0;
}
</style>